import Axios from "axios";
var BatchManageService = (function () {
    function BatchManageService() {
    }
    BatchManageService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/goods_batch/list", { params: params });
    };
    BatchManageService.prototype.updateProductionDate = function (params) {
        return Axios.get("supplierclientapi/goods_batch/update_production_date", { params: params });
    };
    BatchManageService.createInstance = function () {
        BatchManageService.getInstance();
    };
    BatchManageService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return BatchManageService;
}());
export default BatchManageService;
